import { useEffect, useState } from 'react';

import { useIdleAutoHideOnMouseMove } from './useIdleAutoHideOnMouseMove.ts';

interface UseAutoHideSpeedDialProps {
  isActive: boolean;
  timeoutMs?: number;
}

/**
 * Hook to auto-hide a component menu when it is not active (closed) and mouse is idle.
 * @param isActive
 * @param timeoutMs
 */
export const useAutoHideComponentMenuWhenClosed = ({
  isActive,
  timeoutMs = 1500,
}: UseAutoHideSpeedDialProps) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const isMenuActive = isMenuOpen || isActive;

  const { isVisible, setIsVisible } = useIdleAutoHideOnMouseMove({
    timeoutMs,
    pauseTimer: isMenuActive,
  });

  // Ensure visibility when state changes even without mouse movement
  useEffect(() => {
    if (isMenuActive) setIsVisible(true);
  }, [isMenuActive, setIsVisible]);

  return { isVisible, setIsMenuOpen };
};
